import { Component } from '@angular/core';

@Component({
  selector: 'app-oil-gas-tab',
  standalone: false,
  templateUrl: './oil-gas-tab.component.html',
  styleUrl: './oil-gas-tab.component.scss'
})
export class OilGasTabComponent {

}
